module.exports = __webpack_public_path__ + "img/159.d3e89921.jpg";